module.exports = __webpack_public_path__ + "img/relief-dude.837c8e9d.png";